'use client'

import { useEffect, useMemo } from 'react'
import { usePathname, useRouter } from 'next/navigation'

const PROMANITY_PHASE_1_ALLOWED_PATHS = [
  '/',
  '/dashboard',
  '/launchpad',
  '/home',
  '/community',
  '/login',
  '/logout',
  '/funnel-builder',
  '/funnel-view',
  '/f',
  '/product',
  '/orders',
  '/settings',
]

function normalizePathname(pathname: string) {
  if (!pathname) return '/'

  const clean = pathname.split('?')[0]

  if (clean.length > 1 && clean.endsWith('/')) {
    return clean.slice(0, -1)
  }

  return clean
}

function isAllowedPath(pathname: string) {
  const currentPathname = normalizePathname(pathname)

  return PROMANITY_PHASE_1_ALLOWED_PATHS.some((allowedPath) => {
    if (allowedPath === '/') {
      return currentPathname === '/'
    }

    return (
      currentPathname === allowedPath ||
      currentPathname.startsWith(`${allowedPath}/`)
    )
  })
}

export function PromanityPhaseClientGuard({
  children,
  isPromanity,
  phase2Enabled,
  isOwner,
  isAdmin,
}: {
  children: React.ReactNode
  isPromanity: boolean
  phase2Enabled: boolean
  isOwner: boolean
  isAdmin: boolean
}) {
  const router = useRouter()
  const pathnameFromHook = usePathname()

  const pathname = useMemo(() => {
    return normalizePathname(pathnameFromHook || '/')
  }, [pathnameFromHook])

  const allowedPath = isAllowedPath(pathname)

  const shouldRedirect =
    isPromanity &&
    !phase2Enabled &&
    !isOwner &&
    !isAdmin &&
    !allowedPath

  useEffect(() => {
    console.log('[Promanity client phase guard]', {
      pathname,
      isPromanity,
      phase2Enabled,
      isOwner,
      isAdmin,
      allowedPath,
      shouldRedirect,
    })

    if (shouldRedirect) {
      router.replace('/dashboard')
    }
  }, [
    pathname,
    isPromanity,
    phase2Enabled,
    isOwner,
    isAdmin,
    allowedPath,
    shouldRedirect,
    router,
  ])

  if (shouldRedirect) {
    return null
  }

  return <>{children}</>
}